export default __webpack_public_path__ + "static/media/safari-logo.aa1461b9.svg";